import { Component } from '@angular/core';
import { Platform, NavController, Nav, ModalController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
// import { SplashScreen } from '@ionic-native/splash-screen';

// import { HomePage } from '../pages/home/home';
// import { LoginPage } from '../pages/login/login';
import { DIC } from '../pages/dic';
// import { GlobalPage } from '../pages/global/global';
import { GN } from '../gn';
import { Deeplinks } from '@ionic-native/deeplinks';

import { ViewChild } from '@angular/core';
// import * as html2canvas from 'html2canvas';
import { FeedbackPage } from '../pages/feedback/feedback';
import { GlhomePage } from '../pages/gps-link/glhome/glhome';
import { locale } from 'moment';
// import { OneSignal } from '@ionic-native/onesignal';
import { MapviewPage } from '../pages/mapview/mapview';
import { MapviewMapview2Page } from '../pages/mapview-mapview2/mapview-mapview2';
// import {} from '@angular/core';
import { Capacitor } from '@capacitor/core';
import * as moment from 'moment';

declare var html2canvas;

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any;
  // rootPage:any = HomePage;

  @ViewChild(Nav) navChild: Nav;

  // constructor(public oneSignal: OneSignal, platform: Platform, statusBar: StatusBar, public dic: DIC, public gn: GN, deeplinks: Deeplinks, public modalCtrl: ModalController) {
  constructor(platform: Platform, statusBar: StatusBar, public dic: DIC, public gn: GN, deeplinks: Deeplinks, public modalCtrl: ModalController) {
    // enableProdMode()
    dic.checkUserLanguage()
    dic.initLanguage()

    // Samo ako e Nativna aplikacija ke bide TRUE
    //this.gn.isApp = true

    var _that = this

    //console.log('window.location.origin=' + window.location.origin)
    // if (window.location.origin.indexOf('localhost:8100') != -1 || window.location.origin.indexOf('panorama.gps.mk') != -1) {
    //   this.gn.isApp = false
    // } else {
    //   this.gn.isApp = true
    // }

    this.gn.isApp = false
    var myPlatform = Capacitor.getPlatform()
    if (myPlatform == 'web') {
      this.gn.isApp = false
    } else {
      this.gn.isApp = true

    }
    // console.log(this.gn.isApp)




    var _that = this
    console.log(this.gn.isApp, window.location.origin)
    // Okay, so the platform is ready and our plugins are available.
    // Here you can do any higher level native things you might need.
    statusBar.styleDefault();
    // statusBar.overlaysWebView(false)
    // splashScreen.hide();

    this.initApplikacija()

    platform.ready().then(() => {
      if (this.gn.isApp) {
        if (myPlatform == 'android') {
          this.gn.showPromptForPrivacy(function (tf) {
            if (tf == true) {
              // _that.oneSignal.startInit('9e91874c-dea5-4d92-a7e1-69f2e89250c7', '519363461516');
              // _that.oneSignal.inFocusDisplaying(_that.oneSignal.OSInFocusDisplayOption.Notification);
              // _that.oneSignal.setSubscription(true);
              // _that.oneSignal.handleNotificationReceived().subscribe(() => {
              //   // your code after Notification received.
              // });
              // _that.oneSignal.handleNotificationOpened().subscribe(() => {

              // });
              // var notificationOpenedCallback = function (jsonData) {
              //   console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
              // };
              // _that.oneSignal.endInit();


              // _that.oneSignal.getIds().then((ids) => {
              //   console.log("******* TOKEN ********")
              //   console.log(ids.userId, ids.pushToken)
              //   _that.gn.PushToken = ids.userId + '';
              // })
            }

          })
        } else {
          // this.oneSignal.startInit('9e91874c-dea5-4d92-a7e1-69f2e89250c7', '519363461516');
          // this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);
          // this.oneSignal.setSubscription(true);
          // this.oneSignal.handleNotificationReceived().subscribe(() => {
          //   // your code after Notification received.
          // });
          // this.oneSignal.handleNotificationOpened().subscribe(() => {
          //   // your code to handle after Notification opened
          //   //   if (_that.gn.openChatOrderId+''!='-1'){

          //   //     if (_that.gn.reloadChatFunction!=null){
          //   //         _that.gn.reloadChatFunction()
          //   //     }
          //   // }else{
          //   //     _that.gn.services.loadChatNotif() 


          //   // }
          // });
          // var notificationOpenedCallback = function (jsonData) {
          //   console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
          // };
          // this.oneSignal.endInit();


          // this.oneSignal.getIds().then((ids) => {
          //   console.log("******* TOKEN ********")
          //   console.log(ids.userId, ids.pushToken)
          //   this.gn.PushToken = ids.userId + '';
          // })

        }
      }
    });









    // if (this.gn.isApp==false){
    //   this.initApplikacija()
    // }




    // window["MyFeedBackFunction"] = function(){
    //   _that.feedback()
    // }

  }

  initApplikacija() {
    var _that = this
    var _h = window.location.hash
    if (_h == null) { _h = '' }

    var tf = false
    //_h = '#resetpasskiki@gps.mk?l=mk'
    //_h = "#admin527160-657300-689626-894010"
    //_h = "#admin527160-657300-689626-894010#deflangen"
    //https://panorama.gps.mk/login/#resetpassgoran@gps.mk?l=mk
    console.log('.' + _h.substring(0, 18) + '.')
    if (_h.substring(0, 18) == '#/login/_resetpass') {
      console.log('AAA')
      var _emailuser = _h.split('_resetpass')[1].split('?')[0]
      // console.log(_emailuser)
      if (_emailuser != '') {
        this.gn.resetPassUser = _emailuser
        history.replaceState(null, null, ' ');
        // this.rootPage = LoginPage
        // console.log(_emailuser)
        this.rootPage = 'login'
      }
    } else {
      console.log('BBB')
    }

    if (_h.substring(0, 6) == '#admin') {
      var _arrHash = _h.split('#') //DA
      //_h = _h.substring(1).replace('admin', '') //NE
      _h = _arrHash[1].replace('admin', '') //DA
      var _l = _arrHash[2].replace('deflang', '') //DA
      if (_h.length > 5) {
        tf = true
        this.gn._Post('/api/gn/checkadmintoken', { t: this.gn.crypt(_h) }, function (_data) {
          localStorage.setItem("PANQAWSEDRF", _that.gn.crypt(_data.K))

          if (_data.K != 0) {
            localStorage.setItem("UPDATE-PANPASS", moment(_data.LU).format('YYYY-MM-DD HH:mm:ss'))
            localStorage.setItem("CHECK-PANPASS", moment().format('YYYY-MM-DD HH:mm:ss'))
          }

          location.href = './'
          _that.dic.changeLanguage(_l) //DA
        })
      }
    }
    if (_h == '#vehdetails') {
      tf = true
      _that.rootPage = MapviewMapview2Page
    }

    if (tf == false) {
      this.gn.checkUserHash(function () {
        if (_that.gn.user.UserId == -1) {
          // _that.rootPage = LoginPage
          _that.rootPage = 'login'
        } else {
          if (_that.gn.isGPSLINK) {
            _that.rootPage = GlhomePage
          } else {
            // GlhomePage
            // _that.rootPage = HomePage
            _that.rootPage = 'home'
          }

        }
      })
    }
  }
  feedback() {
    var _that = this
    var div = document.getElementsByTagName('ion-content')
    // var div = divs[divs.length-1]
    // var div = (<HTMLBodyElement>document.body)

    var options = {
      pagesplit: true,
      background: "white",
      height: div[0].clientHeight,
      width: div[0].clientWidth,
      useCORS: true,
      allowTaint: true
    };

    var GlobalCanvas = document.createElement('canvas')
    GlobalCanvas.width = document.body.clientWidth
    GlobalCanvas.height = document.body.clientHeight

    var ctx = GlobalCanvas.getContext('2d')

    html2canvas(div[0], options).then((canvas) => {
      let imgData = canvas.toDataURL("image/JPEG");
      var k = parseFloat(GlobalCanvas.width + '') / parseFloat(canvas.width + '')
      console.log(canvas.width, canvas.height)
      var id = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);

      ctx.putImageData(id, 0, 0, 0, 0, canvas.width * k, canvas.height * k);
      var dd = GlobalCanvas.toDataURL("image/JPEG");

      // console.log(imgData)
      let wmsg = _that.modalCtrl.create(FeedbackPage, { img: dd });
      wmsg.present();
    })
  }
}



// import { Component } from '@angular/core';
// import { Platform, NavController, Nav, ModalController } from 'ionic-angular';
// import { StatusBar } from '@ionic-native/status-bar';
// // import { SplashScreen } from '@ionic-native/splash-screen';

// import { HomePage } from '../pages/home/home';
// import { LoginPage } from '../pages/login/login';
// import { DIC } from '../pages/dic';
// import { GlobalPage } from '../pages/global/global';
// import { GN } from '../gn';
// import { Deeplinks } from '@ionic-native/deeplinks';

// import { ViewChild } from '@angular/core';
// import * as html2canvas from 'html2canvas';
// import { FeedbackPage } from '../pages/feedback/feedback';
// import { GlhomePage } from '../pages/gps-link/glhome/glhome';
// import { NotificationmodalPage } from '../pages/notificationmodal/notificationmodal';
// import { locale } from 'moment';

// @Component({
//   templateUrl: 'app.html'
// })
// export class MyApp {
//   rootPage: any;
//   // rootPage:any = HomePage;

//   @ViewChild(Nav) navChild: Nav;

//   constructor(platform: Platform, statusBar: StatusBar, public dic: DIC, public gn: GN, deeplinks: Deeplinks, public modalCtrl: ModalController) {
//     dic.checkUserLanguage()
//     dic.initLanguage()
//     platform.ready().then(() => {
//       // Okay, so the platform is ready and our plugins are available.
//       // Here you can do any higher level native things you might need.
//       statusBar.styleDefault();
//       // splashScreen.hide();



//     });

//     var _h = window.location.hash
//     if (_h == null) { _h = '' }

//     var _that = this

//     var tf = false
//     // alert(window.location)
//     // alert(_h)
//     if (_h.substring(0, 6) == '#admin') {
//       _h = _h.substring(1).replace('admin', '')
//       if (_h.length > 5) {
//         tf = true
//         this.gn._Post('/api/gn/checkadmintoken', { t: this.gn.crypt(_h) }, function (_data) {
//           localStorage.setItem("PANQAWSEDRF", _that.gn.crypt(_data.K))
//           location.href = './'
//           // _that.gn.checkUserHash(function () {    
//           //   if (_that.gn.user.UserId == -1) {
//           //     _that.rootPage = LoginPage
//           //   } else {
//           //     if (_that.gn.isGPSLINK){
//           //       _that.rootPage = GlhomePage
//           //     }else{
//           //       _that.rootPage = HomePage
//           //     }

//           //   }
//           // })
//           //https://panorama.gps.mk/?q=alarm&t=1234
//           //http://localhost:8100/?q=alarmna&vid=6288&dt=2019-05-27%20%12:31:20.896

//         })
//       }
//     }

//     if (tf == false) {
//       this.gn.checkUserHash(function () {
//         var urlParams = new URLSearchParams(window.location.search);
//         if (urlParams.get('q') == 'alarmna') {
//           _that.rootPage = NotificationmodalPage
//         } else {
//           if (_that.gn.user.UserId == -1) {
//             _that.rootPage = LoginPage
//           } else {
//             if (_that.gn.isGPSLINK) {
//               _that.rootPage = GlhomePage
//             } else {
//               // GlhomePage
//               _that.rootPage = HomePage
//             }
//           }
//         }
//       })
//     }



//     // window["MyFeedBackFunction"] = function(){
//     //   _that.feedback()
//     // }

//   }


//   feedback() {
//     var _that = this
//     var div = document.getElementsByTagName('ion-content')
//     // var div = divs[divs.length-1]
//     // var div = (<HTMLBodyElement>document.body)

//     var options = {
//       pagesplit: true,
//       background: "white",
//       height: div[0].clientHeight,
//       width: div[0].clientWidth,
//       useCORS: true,
//       allowTaint: true
//     };

//     var GlobalCanvas = document.createElement('canvas')
//     GlobalCanvas.width = document.body.clientWidth
//     GlobalCanvas.height = document.body.clientHeight

//     var ctx = GlobalCanvas.getContext('2d')

//     html2canvas(div[0], options).then((canvas) => {
//       let imgData = canvas.toDataURL("image/JPEG");
//       var k = parseFloat(GlobalCanvas.width + '') / parseFloat(canvas.width + '')
//       console.log(canvas.width, canvas.height)
//       var id = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);

//       ctx.putImageData(id, 0, 0, 0, 0, canvas.width * k, canvas.height * k);
//       var dd = GlobalCanvas.toDataURL("image/JPEG");

//       // console.log(imgData)
//       let wmsg = _that.modalCtrl.create(FeedbackPage, { img: dd });
//       wmsg.present();
//     })
//   }
// }




// WEBPACK FOOTER //
// ./src/app/app.component.ts